<template>
    <div>
        <div class="row align-items-center">
            <div class="col-12 text-center" v-if="areReportsLoading">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">{{ $t('Loading...') }}</span>
                </div>
            </div>
            <div v-else-if="byUser.length" class="col-12">
                <div class="card pointer" @click="openCard(index)" v-for="(report, index) in byUser" :key="index">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-auto">
                                <button class="btn pointer" v-if="selectedReportIndex===index">
                                    <i class="fe fe-chevron-down"></i>
                                </button>
                                <button class="btn" v-else>
                                    <i class="fe fe-chevron-right"></i>
                                </button>
                            </div>
                            <div class="col">
                                {{ report.member.firstName }}
                                {{ report.member.lastName }}
                                <br/>
                                <small
                                    class="text-muted"
                                    v-if="report.member.specialty"
                                >{{ report.member.specialty.label }}</small>
                            </div>
                            <div class="col text-muted">
                                <money :value="report.earnings"></money>
                                <br/>
                                <small class="text-muted">{{ $t('Earnings') }}</small>
                            </div>
                            <div class="col text-muted">
                                <money :value="debt(report)"></money>
                                <br/>
                                <small class="text-muted">{{ $t('Debt') }}</small>
                            </div>
                            <div class="col text-muted">
                                <money :value="report.paid"></money>
                                <br/>
                                <small class="text-muted">{{ $t('Payed') }}</small>
                            </div>
                            <div class="col">
                                <money :value="report.revenue"></money>
                                <br/>
                                <small
                                    class="text-muted"
                                    v-if="report.member.revenuePercent"
                                >{{ $t('Revenue') }} ({{ report.member.revenuePercent.value }}%)</small>
                            </div>
                            <div class="col text-muted" v-if="false">
                                <money :value="report.leftover"></money>
                                <br/>
                                <small class="text-muted">{{ $t('Left over') }}</small>
                            </div>
                            <div class="col text-muted">
                                <money :value="report.member.balance || 0"></money>
                                <br/>
                                <small class="text-muted">{{ $t('Balance') }}</small>
                                <div v-if="selectedReportIndex === index && report.member.balance>0">
                                    <button
                                        @click="openPayoutModal(report.member)"
                                        class="btn btn-sm btn-outline-info"
                                    >{{ $t('Payout') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5" v-if="selectedReportIndex === index">
                            <div class="col">
                                <table class="table table-sm table-nowrap my-4" style="width:100%">
                                    <thead>
                                    <tr>
                                        <th scope="col" style="width:65%">{{ $t('Service') }}</th>
                                        <th scope="col" class="text-center">{{ $t('Quantity') }}</th>
                                        <th scope="col" class="text-right">{{ $t('Cost') }}</th>
                                        <th scope="col" class="text-right">{{ $t('Total') }}</th>
                                        <th scope="col" class="text-right">{{ $t('Revenue') }}(%)</th>
                                    </tr>
                                    </thead>
                                    <tbody v-for="(service, serviceIndex) in report.details" :key="serviceIndex">
                                    <tr v-if="service.treatment">
                                        <td class="long-name">{{ service.treatment.label }}</td>
                                        <td class="text-center">{{ service.quantity || 1 }}</td>
                                        <td class="text-right">
                                            <money :value="service.price"></money>
                                        </td>
                                        <td class="text-right">
                                            <money :value="service.totalPrice"></money>
                                        </td>
                                        <td class="text-right">
                                            <money :value="service.revenue"></money>
                                        </td>
                                    </tr>
                                    </tbody>
                                    <thead></thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="col-12 text-center">
                <div class="card">
                    <div class="card-body">{{ $t("Nothing yet") }}</div>
                </div>
            </div>
        </div>
        <payout-modal id="payoutModal"></payout-modal>
    </div>
</template>

<script>
import Percent from '@/components/Percent.vue';
import DateFilter from '@/components/DateFilter.vue';
import TeamFilter from '@/components/TeamFilter.vue';
import Doughnut from '@/components/Charts/Doughnut.vue'
import LineChart from '@/components/Charts/LineChart.vue'
import PayoutModal from '@/components/PayoutModal';
import Money from '@/components/Money.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'

export default {
    components: {
        Percent,
        Doughnut,
        LineChart,
        DateFilter,
        TeamFilter,
        PayoutModal,
        Money
    },
    props: { user: Array, dates: Object, branchesId: Array },
    mixins: [modalMixins],
    data() {
        return {
            selectedReportIndex: 0
        }
    },
    computed: {
        ...mapGetters('my-team', { getMember: 'get' }),
        ...mapGetters('sales-reports', { getReportFromStore: 'get' }),
        ...mapState('sales-reports', { areReportsLoading: 'isFindPending' }),

        byUser() {
            const report = this.getReportFromStore('report')
            return report.byUser.map(item => {
                if (!item.member) return { ...item, member: { firstName: this.$t('Company') } };
                return item
            })
        }
    },

    watch: {
        user(newUser) {
            this.fetchSalesReport();
        },

        branchesId(branchesId) {
            this.fetchSalesReport();
        },

        dates(dates) {
            this.fetchSalesReport();
        }
    },
    created() {
        this.fetchSalesReport();
    },

    methods: {
        ...mapActions('sales-reports', ['find']),

        openPayoutModal(member) {
            let data = {
                model: member,
                _id: 'temp'
            };
            const { User } = this.$FeathersVuex
            new User(data);

            this.openModal({ id: 'payoutModal' });
        },

        debt(report) {
            if (report.paid > report.earnings)
                return 0;
            return report.earnings - report.paid;
        },

        openCard(index) {
            if (this.selectedReportIndex === index)
                this.selectedReportIndex = null;
            else
                this.selectedReportIndex = index
        },

        fetchSalesReport() {
            let query = {};
            if (this.dates.start) {
                query.date = {
                    $gte: this.dates.start,
                    $lte: this.dates.end
                }
            }

            if (this.branchesId.length > 0)
                query.branchesId = this.branchesId;

            if (this.user.length > 0) {
                query.user = { $in: this.user };
            }
            this.find({ query });
        }
    }
}
</script>

<style>
table {
    width: 100%;
}

.long-name {
    max-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
